import { differenceInCalendarDays } from 'date-fns'
import { getShipmentStatusMeta } from 'lib/settings/order'
import { pickupDropoffText } from 'lib/utils/routeSnapshotUtils'

/**
 * Compute a human readable status message for a shipment.
 *
 * This was extracted from the RouteSnapshotShipment component so it can be
 * reused and unit tested independently.
 */
export function formatShipmentStatusMessage(
  shipment: OrderShipment,
  leg?: OrderLeg,
  pickupDate?: Date | null,
): string {
  if (!pickupDate) return 'Status information is unavailable'

  const now = new Date()
  const daysToPickup = differenceInCalendarDays(pickupDate, now)

  if (shipment.state === 'pending') {
    if (daysToPickup > 1) {
      return `Booked: ${daysToPickup} days left for ${pickupDropoffText(leg?.pickup)}`
    } else if (daysToPickup === 1) {
      return `Booked: 1 day left for ${pickupDropoffText(leg?.pickup)}`
    } else if (daysToPickup === 0) {
      return `Booked today for ${pickupDropoffText(leg?.pickup)}`
    } else if (daysToPickup < 0) {
      return 'Booked'
    }

    return 'Status information is unavailable'
  }

  const statusMeta = getShipmentStatusMeta(shipment.state || '')
  return statusMeta?.message || 'Status information is unavailable'
}

export default formatShipmentStatusMessage
